import { render } from "./Recipe.vue?vue&type=template&id=eb8ed5fc&scoped=true"
import script from "./Recipe.vue?vue&type=script&lang=js"
export * from "./Recipe.vue?vue&type=script&lang=js"

import "./recipe.css?vue&type=style&index=0&id=eb8ed5fc&scoped=true&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb8ed5fc"]])

export default __exports__